import { render, staticRenderFns } from "./AvailableToiletFlagSelect.vue?vue&type=template&id=1874754e&"
import script from "./AvailableToiletFlagSelect.vue?vue&type=script&lang=js&"
export * from "./AvailableToiletFlagSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports